<!--教师年龄-->
<template>
    <div class="my-charts">
        <div :id="id" style="margin-top: -30px;"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";

export default {
    name: "lessonAgeEchart",
    props: {
        id:{
            type: String,
            default:"lesson_age_echart"
        },
        age1Count:{
            type: Number,
            default: 0
        },
        age2Count:{
            type: Number,
            default: 0
        },
        age3Count:{
            type: Number,
            default: 0
        },
        age4Count:{
            type: Number,
            default: 0
        },
        age5Count:{
            type: Number,
            default: 0
        },
        age6Count:{
            type: Number,
            default: 0
        },
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
    },
    data() {
        return {
            pieChart: null, // 饼图
            chartOption:{
                title: {
                    show:false,
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    show: true,
                    bottom:-5,
                    textStyle: {
                        color: '#101010',
                    },
                },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "center",
                        style: {
                            text: '',
                            textAlign: "center",
                            lineHeight:30,
                            fontSize: 20,
                            fontWeight: 'bold'
                        },
                    },
                ],
                series: [
                    {
                        name: '教师年龄：',
                        type: 'pie',
                        radius: '60%',
                        color: [
                            '#91cc75',
                            '#fac858',
                            '#ee6666',
                            '#3ba272',
                            '#fc8452',
                            '#9a60b4',
                            '#ea7ccc',
                        ],
                        label: {
                            show: false,
                            position: 'right'
                        },

                        labelLine: {
                            show: true
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            const list = []
            list.push({'value':this.age1Count,'name':"30岁以下"});
            list.push({'value':this.age2Count,'name':"30-35岁"});
            list.push({'value':this.age3Count,'name':"35-40岁"});
            list.push({'value':this.age4Count,'name':"40-45岁 "});
            list.push({'value':this.age5Count,'name':"45-50岁"});
            list.push({'value':this.age6Count,'name':"其他"});
            // list.push({'value':this.age6Count,'name':"50岁以上"});
            this.pieChart = echarts.init(document.getElementById(this.id));
            this.chartOption.series[0].data = []
            this.chartOption.series[0].data = list;
            this.pieChart.setOption(this.chartOption);
        }
    }
};
</script>

<style scoped lang="scss">
.my-charts {
    width: 100%;
    height: calc(50vh - 120px);
    flex-direction: column;
    div {
        width: 100%!important;
        height: calc(50vh - 100px);
    }
}
</style>